import { initFavorites } from './utils/functions.js';
import { initCarListModals } from './utils/functions.js';
import { initMenu } from './utils/functions.js';
import { initCallBackForm } from './utils/functions.js';
import { initStickyHeader } from './utils/functions.js';
import { initFixedMenu } from './utils/functions.js';
import { toTop } from './utils/functions.js';
import { initStaticForm } from './utils/functions.js';
import { initAccordeon } from './utils/functions.js';
import { ResponsiveManager } from './utils/functions.js';
import { initCarsListSwiper } from './utils/functions.js';
import { copyEmailToBuffer } from './utils/functions.js';
import { changeCarsImages } from './utils/functions.js';
import { setCoockie } from './utils/functions.js';

let carsListSwiper = null;

document.addEventListener('DOMContentLoaded', function(){
initFavorites();
initCarListModals();
initMenu();
initCallBackForm();
initStickyHeader();
initFixedMenu();
toTop();
initStaticForm();
initAccordeon();
copyEmailToBuffer();
copyEmailToBuffer();
changeCarsImages();
setCoockie();


const responsive = new ResponsiveManager(768, {
    onMobile: () => {

        // Инициализируем только если еще не инициализирован
        if (!carsListSwiper) {
            carsListSwiper = initCarsListSwiper();
       }
    },
    onDesktop: () => {
            // Уничтожаем если существует
        if (carsListSwiper && carsListSwiper.destroy) {
            carsListSwiper.destroy();
            carsListSwiper = null;
               }
    }
});



});
